import { useEffect, useRef } from 'react';
import * as Session from './Session';

// Minutos de inactividad tras los cuales la sesión se cierra automáticamente.
// Evita que una sesión quede abierta indefinidamente y se vuelva "rancia" (el
// token/sesión del backend caduca y el endpoint de permisos empieza a devolver
// datos degradados). Al vencer, se limpia la sesión y se recarga para forzar un
// re-login limpio. NO depende de MSAL (por eso no tiene los falsos positivos de
// cruzar getAllAccounts con la cookie).
const INACTIVITY_MINUTES = 30;
const INACTIVITY_MS = INACTIVITY_MINUTES * 60 * 1000;

// Eventos que cuentan como "actividad" del usuario. Cualquiera reinicia el timer.
const ACTIVITY_EVENTS = ['mousemove', 'mousedown', 'keydown', 'click', 'scroll', 'touchstart'];

/**
 * Cierra la sesión automáticamente tras un periodo de inactividad del usuario.
 * Solo actúa cuando hay una sesión activa (cookie). El temporizador se reinicia
 * con cada interacción. Al expirar, llama a removeSessionCookie(true), que limpia
 * cookie + localStorage y recarga la página → el usuario cae en el login.
 */
export default function useInactivityLogout() {
    const timerRef = useRef(null);

    useEffect(() => {
        // Si no hay sesión, no hay nada que vigilar.
        if (!Session.userIsLoggedIn()) return;

        const logout = () => {
            // Re-chequear que siga habiendo sesión antes de cerrar (evita cerrar algo
            // ya cerrado por otra vía, p. ej. logout manual).
            if (Session.userIsLoggedIn()) {
                Session.removeSessionCookie(true);
            }
        };

        const resetTimer = () => {
            if (timerRef.current) clearTimeout(timerRef.current);
            timerRef.current = setTimeout(logout, INACTIVITY_MS);
        };

        // Arranca el temporizador y lo reinicia con cada evento de actividad.
        resetTimer();
        ACTIVITY_EVENTS.forEach((evt) =>
            window.addEventListener(evt, resetTimer, { passive: true })
        );

        return () => {
            if (timerRef.current) clearTimeout(timerRef.current);
            ACTIVITY_EVENTS.forEach((evt) => window.removeEventListener(evt, resetTimer));
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}
